<template>
  <aside class="fixed right-5 top-1/2 z-30 hidden -translate-y-1/2 xl:block">
    <div class="w-28 overflow-hidden rounded-[20px] border border-stone-200/80 bg-white/95 py-1.5 shadow-soft backdrop-blur">
      <div class="space-y-1">
        <component
          :is="item.to ? RouterLink : 'a'"
          v-for="item in localizedItems"
          :key="item.key"
          :to="item.to"
          :href="item.href"
          class="group flex flex-col items-center gap-1 py-2 text-center transition hover:bg-brand-50"
        >
          <span class="grid h-8 w-8 shrink-0 place-items-center rounded-[14px] bg-brand-50 text-brand-600 transition group-hover:bg-brand-500 group-hover:text-white">
            <svg v-if="item.icon === 'ticket'" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V7Z" />
              <path d="M9 9h.01M15 15h.01M14 10l-4 4" />
            </svg>
            <svg v-else-if="item.icon === 'receipt'" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M6 3v18l2-1.5L10 21l2-1.5L14 21l2-1.5L18 21V3H6Z" />
              <path d="M9 8h6M9 12h6M9 16h4" />
            </svg>
            <svg v-else-if="item.icon === 'heart'" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M12 21s-6.716-4.284-9.193-8.02C1.007 10.238 2.127 6.5 5.75 5.5c2.238-.618 4.13.324 5.25 1.742C12.12 5.824 14.012 4.882 16.25 5.5c3.623 1 4.743 4.738 2.943 7.48C18.716 16.716 12 21 12 21Z" />
            </svg>
            <svg v-else-if="item.icon === 'calculator'" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <rect x="5" y="3" width="14" height="18" rx="2" />
              <path d="M8 7h8M8 11h2M12 11h2M16 11h0M8 15h2M12 15h2M16 15h0M8 19h2M12 19h6" />
            </svg>
            <svg v-else-if="item.icon === 'phone'" class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.79.63 2.64a2 2 0 0 1-.45 2.11L8 9.76a16 16 0 0 0 6.24 6.24l1.29-1.29a2 2 0 0 1 2.11-.45c.85.3 1.74.51 2.64.63A2 2 0 0 1 22 16.92Z" />
            </svg>
            <svg v-else class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M6 6h15l-1.5 8.5a2 2 0 0 1-2 1.5H9a2 2 0 0 1-2-1.5L5 4H2" />
              <circle cx="9" cy="20" r="1.5" />
              <circle cx="18" cy="20" r="1.5" />
            </svg>
          </span>
          <div class="min-w-0">
            <div class="text-[11px] font-medium leading-3.5 text-stone-700 transition group-hover:text-brand-700">
              {{ item.label }}
            </div>
            <div class="mx-auto mt-0.5 h-[2px] w-6 rounded-full bg-[linear-gradient(90deg,#ff7e00,#ffd5ae)] opacity-60 transition group-hover:w-8"></div>
          </div>
        </component>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  }
});

const { locale } = useI18n();

const localizedItems = computed(() =>
  props.items.map((item) => ({
    ...item,
    label: item.label?.[locale.value] || item.label?.th || ""
  }))
);
</script>
